interface Props {
  items: {
    icon?: string;
    children?: React.ReactNode;
    onClick: () => void;
    isActive: boolean;
  }[]
}

const IconButtonSelector = ({ items }: Props) => {
  return (
    <div className="flex items-center border-2 border-s-stroke2 rounded-lg overflow-hidden">
      {
        items.map((item, index) => (
          <button
            key={index}
            className={`w-10 h-10 flex items-center justify-center cursor-pointer transition-colors [&_svg]:size-5 [&_svg]:transition-colors [&_svg]:fill-t-tertiary hover:[&_svg]:fill-t-primary ${item.isActive ? '[&_svg]:!fill-[#2a85ff]' : ''}`}
            onClick={item.onClick}
          >
            {item.children}
          </button>
        ))
      }
    </div>
  )
}

export default IconButtonSelector
